/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ScheduleProducer = {
  id?: string;
  dayOfWeek?: ScheduleProducer.dayOfWeek;
  /**
   * HH:mm format
   */
  localTime?: string;
  zoneId?: string;
  scheduleTypeId?: string;
  createdAt?: string;
  updatedAt?: string;
};
export namespace ScheduleProducer {
  export enum dayOfWeek {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY',
  }
}

